/**
 * BaseAPI to load all classes
 */
import { ArticleClass } from "../API/troubleShooting";
import { AuthClass } from "../API/auth";
import { ConnectintClass } from "../API/connectint";

class API {
    article = new ArticleClass();
    auth = new AuthClass();
    connectint = new ConnectintClass();
}

const api = new API();

export default api;